import { UIState, UIAction, UIActionTypes, SettingsState } from '../../types/gameUI';

const initialState: UIState = {
  gameStats: {
    difficulty: 'Hard',
    moves: 0,
    time: 0,
    leftX: 5,
    rightX: 5,
  },
  modals: {
    designModal: {
      isOpen: false,
      activeTab: 'patterns'
    },
    settingsModal: {
      isOpen: false
    }
  },
  settings: [],
  design: {
    selectedPattern: '1_blue',
    selectedCardTheme: '1_white',
    selectedBackground: 'default'
  },
  indicators: {
    shareIndicator: false,
    hintsIndicator: false,
    hintsCount: 0,
    settingsIndicator: false
  },
  buttons: {
    undoDisabled: true,
    hintsDisabled: false,
    magicWandDisabled: false,
    showMagicWand: true,
    showAutocomplete: false,
    hideDesignFirstTab: false,
    magicWandsCount: 1
  },
  labels: {
    movesLabel: 'Moves',
    timeLabel: 'Time',
    settingsText: 'Settings',
    feedbackText: 'Feedback',
    designText: 'Design',
    autocompleteText: 'Autocomplete'
  },
  isExpanded: false,
  tutorialActive: false,
  isInitialized: false
};

export const gameUIReducer = (state = initialState, action: UIAction): UIState => {
  switch (action.type) {
    case UIActionTypes.UPDATE_UI_STATE:
      return {
        ...state,
        ...action.payload
      };
      
    case UIActionTypes.UPDATE_GAME_STATS:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          ...action.payload
        }
      };

    case UIActionTypes.SET_DIFFICULTY:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          difficulty: action.payload
        }
      };

    case UIActionTypes.INCREMENT_MOVES:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          moves: state.gameStats.moves + 1
        }
      };

    case UIActionTypes.UPDATE_TIME:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          time: action.payload
        }
      };

    case UIActionTypes.RESET_GAME_STATS:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          moves: 0,
          time: 0
        }
      };

    case UIActionTypes.OPEN_DESIGN_MODAL:
      console.log('🎨 OPEN_DESIGN_MODAL reducer triggered');
      return {
        ...state,
        modals: {
          ...state.modals,
          designModal: {
            isOpen: true,
            activeTab: action.payload || state.modals.designModal.activeTab
          },
          settingsModal: {
            ...state.modals.settingsModal,
            isOpen: false
          }
        },
        isExpanded: true
      };

    case UIActionTypes.CLOSE_DESIGN_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          designModal: {
            ...state.modals.designModal,
            isOpen: false
          }
        }
      };

    case UIActionTypes.SET_DESIGN_TAB:
      return {
        ...state,
        modals: {
          ...state.modals,
          designModal: {
            ...state.modals.designModal,
            activeTab: action.payload
          }
        }
      };

    case UIActionTypes.OPEN_SETTINGS_MODAL:
      console.log('⚙️ OPEN_SETTINGS_MODAL reducer triggered');
      return {
        ...state,
        modals: {
          ...state.modals,
          settingsModal: {
            isOpen: true
          },
          designModal: {
            ...state.modals.designModal,
            isOpen: false
          }
        },
        isExpanded: true
      };

    case UIActionTypes.CLOSE_SETTINGS_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          settingsModal: {
            isOpen: false
          }
        },
        isExpanded: false
      };

    case UIActionTypes.CLOSE_ALL_PANELS:
      return {
        ...state,
        modals: {
          ...state.modals,
          settingsModal: {
            isOpen: false
          },
          designModal: {
            ...state.modals.designModal,
            isOpen: false
          }
        },
        isExpanded: false
      };

    case UIActionTypes.TOGGLE_SETTING:
      console.log('🔄 TOGGLE_SETTING called for key:', action.payload);
      console.log('📋 Current settings in store:', state.settings);
      const foundSetting = state.settings.find(s => s.key === action.payload);
      console.log('🎯 Found setting:', foundSetting);
      
      return {
        ...state,
        settings: state.settings.map(setting => 
          setting.key === action.payload 
            ? { ...setting, checked: !setting.checked }
            : setting
        )
      };

    case UIActionTypes.UPDATE_SETTINGS:
      console.log('📥 UPDATE_SETTINGS called with payload:', action.payload);
      return {
        ...state,
        settings: action.payload
      };

    case UIActionTypes.SET_PATTERN:
      return {
        ...state,
        design: {
          ...state.design,
          selectedPattern: action.payload
        }
      };

    case UIActionTypes.SET_CARD_THEME:
      return {
        ...state,
        design: {
          ...state.design,
          selectedCardTheme: action.payload
        }
      };

    case UIActionTypes.SET_BACKGROUND:
      return {
        ...state,
        design: {
          ...state.design,
          selectedBackground: action.payload
        }
      };

    case UIActionTypes.SET_INDICATOR:
      return {
        ...state,
        indicators: {
          ...state.indicators,
          [action.payload.key]: action.payload.value
        }
      };

    case UIActionTypes.SET_HINTS_COUNT:
      return {
        ...state,
        indicators: {
          ...state.indicators,
          hintsCount: action.payload
        }
      };

    // Button actions - здесь можно добавить побочные эффекты через middleware
    case UIActionTypes.SHARE_BUTTON_CLICKED:
    case UIActionTypes.TUTORIAL_BUTTON_CLICKED:
    case UIActionTypes.MAGIC_WAND_CLICKED:
    case UIActionTypes.AUTOCOMPLETE_CLICKED:
      return state;

    default:
      return state;
  }
}; 